import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { Form } from '@micromag/core/components';
import { useUrlGenerator } from '@micromag/core/contexts';

import useThemeDuplicate from '../../hooks/useThemeDuplicate';

const propTypes = {
    theme: MicromagPropTypes.story.isRequired,
    className: PropTypes.string,
    fields: MicromagPropTypes.formFields,
    onComplete: PropTypes.func,
    onCancel: PropTypes.func,
};

const defaultProps = {
    fields: [
        {
            name: 'title',
            type: 'text',
            label: <FormattedMessage defaultMessage="Title" description="Field label" />,
        },
    ],
    onComplete: null,
    onCancel: null,
    className: null,
};

const ThemeDuplicateForm = ({ theme, fields, onComplete, onCancel, className }) => {
    const { id, title, type } = theme || {};
    const intl = useIntl();
    const url = useUrlGenerator();
    const { duplicate: duplicateTheme } = useThemeDuplicate(id);
    const postForm = useCallback((action, data) => duplicateTheme(data), [duplicateTheme]);

    return (
        <Form
            action={url('themes.duplicate', { theme: id })}
            fields={fields}
            postForm={postForm}
            initialValue={{
                id,
                title: `${title} ${intl.formatMessage({
                    defaultMessage: ' (copy)',
                    description: 'Copy duplicate',
                })}`,
                type,
            }}
            submitButtonLabel={
                <FormattedMessage defaultMessage="Duplicate theme" description="Button label" />
            }
            onComplete={onComplete}
            onCancel={onCancel}
            className={className}
        />
    );
};

ThemeDuplicateForm.propTypes = propTypes;
ThemeDuplicateForm.defaultProps = defaultProps;

export default ThemeDuplicateForm;
